import React, {FC, memo} from "react";
import {AccessoriesSettingsProps} from "./AccessoriesSettings-types";
import {generateUid} from "../../utils/ApplicationUtils";
import AccessoriesSection from "../AccessoriesSection/AccessoriesSection";
import {useAccessoriesSelected} from "./AccessoriesSettings-hooks";


const AccessoriesSettings: FC<AccessoriesSettingsProps> = memo((props) => {
    const {accessories, onOptionSelect} = props;

    const selected = useAccessoriesSelected(accessories);

    return (
        <>
            {
                selected.map(accessoire => {
                    const uid = generateUid(accessoire.id, accessoire.attributes[0].id);

                    return (
                        <div key={uid}>
                            <AccessoriesSection
                                uid={uid}
                                accessoire={accessoire}
                                onOptionSelect={onOptionSelect}/>
                        </div>
                    );
                })
            }
        </>
    );
});

export default AccessoriesSettings;
